export default __webpack_public_path__ + "src/images/packages/palms-on-the-rocks/5f7951bf3939a40d983aec72e9f8029f-3.jpg";